export default __webpack_public_path__ + "static/media/ac-logo-white.cfca92da.svg";